import type { ComponentType, HTMLAttributes } from "react";
import { Tag as AntdTag, type TagProps as AntdTagProps } from "antd";

import type { CheckableTagProps as AntdCheckableTagProps } from "antd/es/tag/CheckableTag";

export type TagProps = AntdTagProps;
export const Tag = AntdTag;

export type CheckableTagProps = AntdCheckableTagProps & HTMLAttributes<HTMLSpanElement>;
export const CheckableTag = AntdTag.CheckableTag as ComponentType<CheckableTagProps>;
